import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { theme } from "../../../../../helpers/theme";

import { useState } from "react";
import { LoadingBackDrop } from "../../../../../components/loader";

import { getAllOffers } from "../../../../../services/offers/get-all-offers";
import { OffersItem } from "../../../../../services/offers/get-all-offers/types";
import OfferingOfferEditForm from "./offering-edit-offer-form";
import { GoBackButton } from "../../../../../components/GoBackButton";

const OfferingOfferEdit = () => {
  const { id } = useParams();
  const [offer, setOffer] = useState<OffersItem>();
  const body = {
    paginacja: null,
    filtr: {
      id_oferty: id,
    },
  };
  const GetAllOffers = useQuery(["AllOffers"], () => getAllOffers(body), {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onSuccess(data) {
      setOffer(data.data.payload.oferty[0]);
    },
  });

  if (
    GetAllOffers.isLoading ||
    GetAllOffers.isRefetching ||
    offer === undefined
  ) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <>
      <ButtonWrapper>
        <GoBackButton description={"Powrót"} goToUrl={-1} />
      </ButtonWrapper>
      <OfferEditContainer>
        <OfferingOfferEditForm offer={offer} />
      </OfferEditContainer>
    </>
  );
};

export default OfferingOfferEdit;

const OfferEditContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-left: 0;
  margin-top: 0px;
  padding-top: 20px;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
    width: 70%;
    margin-top: -50px;
  }
`;
const ButtonWrapper = styled.div`
  width: 70%;
  margin-left: 30px;
  // display: flex;
  // justify-content: flex-start;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
  }
`;
